import { createSelector } from '@reduxjs/toolkit'
import flow from 'lodash/flow'

import { isLoading } from '../shared/withLoadingState'
import { getCustomFields } from '../root.selectors'

export const getCustomFieldsByCacheKey = createSelector(
  [getCustomFields, (_state, cacheKey) => cacheKey],
  (slice, cacheKey) => slice.data[cacheKey],
)

export const isLoadingCustomFields = flow(getCustomFields, isLoading)
